/* 3D4M custom scroll-mark (Brand identity §12).
   De native scrollbar is verborgen (3d4m-overrides.css); deze edge-mark vervangt 'm:
   volgt de scroll-positie, detecteert .band--dark voor de kleur-flip, heeft
   is-scrolling/is-hovering/is-dragging states + drag-to-scroll (muis + touch).
   Markup staat in layout/theme.liquid, styling in brand-v3.css (.scroll-rail/.scroll-mark).
   Bron: Concept-pages-3.0 (storefront-pagina's, drag-enabled variant). */
(function () {
  var rail = document.getElementById('scroll-rail');
  var mark = document.getElementById('scroll-mark');
  if (!rail || !mark) return;
  var ticking = false;
  var idleTimer = null;
  var darkBands = [];

  function refreshDarkBands() {
    darkBands = Array.prototype.slice.call(document.querySelectorAll('.band--dark, .site-footer'))
      .map(function (el) {
        var rect = el.getBoundingClientRect();
        return { top: rect.top + window.scrollY, bottom: rect.bottom + window.scrollY };
      });
  }
  function tick() {
    ticking = false;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) { rail.style.display = 'none'; return; }
    rail.style.display = '';
    var pct = Math.max(0, Math.min(1, window.scrollY / docHeight));
    mark.style.top = (pct * (rail.offsetHeight - mark.offsetHeight)) + 'px';
    var markRect = mark.getBoundingClientRect();
    var probeY = window.scrollY + markRect.top + markRect.height / 2;
    var onDark = darkBands.some(function (b) { return probeY >= b.top && probeY < b.bottom; });
    rail.classList.toggle('on-dark', onDark);
  }
  function onScroll() {
    if (!ticking) { requestAnimationFrame(tick); ticking = true; }
    mark.classList.add('is-scrolling');
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { mark.classList.remove('is-scrolling'); }, 520);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { refreshDarkBands(); tick(); }, { passive: true });
  setTimeout(function () { refreshDarkBands(); tick(); }, 50);
  setTimeout(function () { refreshDarkBands(); tick(); }, 400);

  /* Drag-to-scroll */
  var isDragging = false;
  var startY = 0;
  var startScroll = 0;
  function startDrag(e) {
    isDragging = true;
    mark.classList.add('is-dragging');
    document.documentElement.style.scrollBehavior = 'auto';
    startY = (e.touches ? e.touches[0].clientY : e.clientY);
    startScroll = window.scrollY;
    e.preventDefault();
  }
  function moveDrag(e) {
    if (!isDragging) return;
    var y = (e.touches ? e.touches[0].clientY : e.clientY);
    var dy = y - startY;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var railHeight = rail.offsetHeight - mark.offsetHeight;
    var scrollDelta = (dy / railHeight) * docHeight;
    window.scrollTo(0, startScroll + scrollDelta);
  }
  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    mark.classList.remove('is-dragging');
    document.documentElement.style.scrollBehavior = '';
  }
  mark.addEventListener('mouseenter', function () { mark.classList.add('is-hovering'); });
  mark.addEventListener('mouseleave', function () { mark.classList.remove('is-hovering'); });

  mark.addEventListener('mousedown', startDrag);
  mark.addEventListener('touchstart', startDrag, { passive: false });
  window.addEventListener('mousemove', moveDrag);
  window.addEventListener('touchmove', moveDrag, { passive: false });
  window.addEventListener('mouseup', endDrag);
  window.addEventListener('touchend', endDrag);
})();
